import { useKeyPress } from "react-use";
import { useEffect } from "react";

const useKeyPressWithCallback = (keyFilter: string, callback?: () => void) => {
  const [keyPressed] = useKeyPress(keyFilter);
  useEffect(() => {
    if (keyPressed) {
      callback?.();
    }
  }, [keyPressed]);
};

export default useKeyPressWithCallback;
